<script setup>
import AuthLayout from '@/layouts/AuthLayout.vue';
import ResetPasswordForm from '@/components/form/ResetPasswordForm.vue';
</script>

<template>
  <auth-layout>
    <template #content>
      <section class="container py-32 z-10 relative h-full flex-grow">
        <div
          class="flex flex-col flex-1 max-w-xs lg:max-w-4xl mx-auto justify-center items-center h-full lg:space-x-5"
        >
          <div class="w-full lg:w-4/6 mb-6 lg:mb-0 text-center">
            <h2 class="mb-5 text-5xl text-green-700 font-semibold">
              Ghana Connect
            </h2>
            <h1 class="text-4xl text-amber-500 border-b border-amber-500 inline">
              Reset Password
            </h1>
            <p class="text-base text-gray-600 my-5">
              Enter your email below to reset your password
            </p>
          </div>
          <div class="w-full lg:w-4/6">
            <ResetPasswordForm />
          </div>
        </div>
      </section>
    </template>
  </auth-layout>
</template>

<style scoped></style>
